import { useState, useEffect, useRef, useMemo } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import { FaEdit } from "react-icons/fa";
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'

import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const Companies = () => {
    const [Companies, setCompanies] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const gridRef = useRef();

    const navigate = useNavigate()

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        setIsLoading(true)
        try {
            const response = await Server.get('/companies/')
            setCompanies(response?.data)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
          localStorage.removeItem('user')
          navigate('/login')
      }else if (error?.response?.status === 403){
        toast.error(error?.response?.data?.detail || 'Forbidden');
        navigate('/');
      }else {
        toast.error(error?.response?.data?.detail || 'Failed to fetch companies')
      }
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        {
            headerName: "Name",
            field: "name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Resp.Name",
            field: "resp_person",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Resp.Contact",
            field: "resp_phone",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Address",
            field: "address",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Status",
            field: "status",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Branches",
            field: "branches",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Actions",
            pinned: 'left',
            minWidth: 80,
            sortable: false,
            filter: false,
            cellRenderer: (e) => {
                if (!e.data) return null;
                return (
                    <div className="d-flex gap-1">
                        <Link className="btn btn-outline-info" title="Edit company" to="/update-company" state={{ company: e.data }}>
                            <FaEdit/>
                        </Link>
                    </div>
                );
            },
        },
    ], []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="row">
            <div className="col-md-12">
                <Link to='/add-company' className="btn btn-outline-info mb-2" style={{float: 'right'}}>Add company</Link>
            </div>
        </div>
        <div className="card">

            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Companies</h3>
            </div>
            <div className="card-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            suppressMenuHide={true}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            defaultColDef={defaultColDef}
                            rowData={Companies}
                            domLayout={"normal"}
                            rowSelection={"multiple"}

                            animateRows={true}

                            pagination={false}
                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}

                            ref={gridRef}
                            groupIncludeTotalFooter={false}
                            groupIncludeFooter={false}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                </div>
            </div>
        </div>
        </div>
      <br/>
    </>
  )
}

export default Companies
